export default __webpack_public_path__ + "static/media/MT4_activations_XZ.d063919d.png";